import { getLeagueLogoUrl } from '../../urls';
import { LEAGUE_NAMES, type ESPNLeagueId } from '../../../shared';
import { LIGHT, bbox, leagueBuilder, team } from '../builders';
import type { LogoVsLogoLeague } from '../types';

const ID: ESPNLeagueId = 'laliga';
const { uniform } = leagueBuilder(ID);

const teams = [
  team('almeria', 'Almería', uniform('almeria', '#ED1C24', LIGHT)),
  team('alaves', 'Alavés', uniform('alaves', '#11339F', '#DDDDDD')),
  team('athletic-club', 'Athletic Club', uniform('athletic-club', '#EE1C25', '#0F3E8A')),
  team('atletico-madrid', 'Atlético de Madrid', uniform('atletico-madrid', '#F62A07', '#9FD3D0')),
  team('barcelona', 'FC Barcelona', uniform('barcelona', '#A30046', '#0054A9')),
  team('real-betis', 'Real Betis', uniform('real-betis', '#00983C', LIGHT)),
  team('cadiz', 'Cádiz', uniform('cadiz', '#FDE607', '#0045A7')),
  team('celta', 'Celta', uniform('celta', '#2B3A59', '#DDDDDD')),
  team('deportivo-la-coruna', 'Deportivo La Coruña', uniform('deportivo-la-coruna', '#641060', LIGHT)),
  team('elche', 'Elche', uniform('elche', '#006422', '#F2C973')),
  team('espanyol', 'Espanyol', uniform('espanyol', LIGHT, '#008BC9')),
  team('getafe', 'Getafe', uniform('getafe', '#0056A1', LIGHT)),
  team('girona', 'Girona', uniform('girona', '#FF0227', '#FFBB00')),
  team('las-palmas', 'Las Palmas', uniform('las-palmas', '#FFE500', '#0049A1')),
  team('leganes', 'Leganés', uniform('leganes', '#073E85', '#E19A00')),
  team('levante', 'Levante', uniform('levante', '#D3013E', '#005CA9')),
  team('malaga', 'Málaga', uniform('malaga', '#00479E', LIGHT)),
  team('mallorca', 'Mallorca', uniform('mallorca', '#FF141F', '#FFF700')),
  team('osasuna', 'Osasuna', uniform('osasuna', '#FF0014', '#001F58')),
  team('racing-santander', 'Racing Santander', uniform('racing-santander', '#009E3B', LIGHT)),
  team('rayo-vallecano', 'Rayo Vallecano', uniform('rayo-vallecano', '#EE3224', LIGHT)),
  team('real-madrid', 'Real Madrid', uniform('real-madrid', LIGHT, '#000000')),
  team('real-oviedo', 'Real Oviedo', uniform('real-oviedo', '#004BA5', LIGHT)),
  team('real-sociedad', 'Real Sociedad', uniform('real-sociedad', '#233096', LIGHT)),
  team('real-valladolid', 'Real Valladolid', uniform('real-valladolid', '#6C1F84', LIGHT)),
  team('sevilla', 'Sevilla', uniform('sevilla', '#D70F21', '#C79100')),
  team('valencia', 'Valencia', uniform('valencia', LIGHT, '#1F1A1A')),
  team('villarreal', 'Villarreal', uniform('villarreal', '#FFE772', '#005188'))
];

export const laliga: LogoVsLogoLeague = {
  value: ID,
  label: LEAGUE_NAMES[ID],
  logo: { src: getLeagueLogoUrl(ID), bbox: bbox(35, 45, 408, 379) },
  teams
};
